import React, { useRef } from "react";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";

// import styles from "./Features.module.sass";
import HeroGestionDocuments from "./HeroGestionDocuments";
import FonctionnalitesContrat from "./FonctionnalitesContrat";
import AvantagesGestion from "./AvantageGestion";  
import SolutionEmargement from "./SolutionEmargement";
import Faq from "./Faq";

const GestionDocuments = () => {
  const scrollToRef = useRef(null);

  const seoData = {
    title: "Gestion de Documents - Dématérialisation complète pour CFA | Edutio",
    description: "Dématérialisez et centralisez tous vos documents de formation avec Edutio. GED spécialisée, signature électronique, archivage sécurisé et conformité RGPD.",
    keywords: "gestion documents CFA, dématérialisation formation, GED CFA, signature électronique, archivage numérique, zéro papier"
  };

  return (
    <>
      <SEOHead {...seoData} />
      <HeroGestionDocuments  scrollToRef={scrollToRef} />
      <AvantagesGestion  className="section-pb" scrollToRef={scrollToRef} />
      <SolutionEmargement />
      <FonctionnalitesContrat />
      <Faq />
      <AppelAction className="section" />
    </>
  );
};

export default GestionDocuments;
